module.exports = __webpack_public_path__ + "static/sport/mb-title-200.a249729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mb-title-200.png
// module id = Hzfu
// module chunks = 0